import {ILinks} from 'Common/config/ILinks';


export function standardLinks(): ILinks
{
	/* The key is the link name, and for pages should be the same as the page name. */

	return {
		'frontend/Home':			{type:'page',page:'frontend/Home',			target:'/'},
		'frontend/Events':			{type:'page',page:'frontend/Events',		target:'/events'},
		'frontend/Event':			{type:'page',page:'frontend/Event',			target:'/event/:slug'},
		'frontend/event/EventArtistProfile':
									{type:'page',page:'frontend/EventArtistProfile',target:'/event/:id/artistProfile'},
		'frontend/Menu':			{type:'page',page:'frontend/Menu',			target:'/menu'},
		'frontend/Food':			{type:'page',page:'frontend/Food',			target:'/food'},
		'frontend/Drinks':			{type:'page',page:'frontend/Drinks',		target:'/drinks'},
		'frontend/MenuPoster':		{type:'page',page:'frontend/MenuPoster',	target:'/menu-poster/:id'},
		'frontend/SpecialPoster':	{type:'page',page:'frontend/SpecialPoster',	target:'/special-poster/:id'},
		'frontend/Hire':			{type:'page',page:'frontend/Hire',			target:'/hire'},
		'frontend/Contact':			{type:'page',page:'frontend/Contact',		target:'/contact'},
		'frontend/Members':			{type:'page',page:'frontend/Members',		target:'/members'},
		'frontend/Reservation':		{type:'page',page:'frontend/Reservation',	target:'/reservation'},
		'frontend/PageNotFound':	{type:'page',page:'frontend/PageNotFound',	target:'/pageNotFound'},

		'backend/Venue':	{type:'page', page:'backend/Venue',		target:'/admin'},
		'backend/Home':		{type:'page', page:'backend/Home',		target:'/admin/home'},
		'backend/Contact':	{type:'page', page:'backend/Contact',	target:'/admin/contact'},
		'backend/Hire':		{type:'page', page:'backend/Hire',		target:'/admin/hire'},
		'backend/Events':	{type:'page', page:'backend/Events',	target:'/admin/events'},
		'backend/Hr':		{type:'page', page:'backend/Hr',		target:'/admin/hr'},
		'backend/Event':	{type:'page', page:'backend/Event',		target:'/admin/event/:slug'},
		
		// discontinued 'backend/event/v2':	{type:'page', page:'backend/event/v2',		target:'/admin/event/v2/:id'},
		'backend/Menu':		{type:'page', page:'backend/Menu',		target:'/admin/menu'},
		'backend/Menus':	{type:'page', page:'backend/Menus',		target:'/admin/menus'},
		'backend/MenuSection':	{type:'page',	page:'backend/MenuSection',	target:'/admin/menuSection'},
		'backend/Course':	{type:'page', page:'backend/Course',	target:'/admin/menu/:course'},
		'backend/MenuItem':	{type:'page', page:'backend/MenuItem',	target:'/admin/menuItem/:id'},
		'backend/Brands':	{type:'page', page:'backend/Brands',	target:'/admin/brands'},
		'backend/Brand':	{type:'page', page:'backend/Brand',		target:'/admin/brand/:id'},
		'backend/Specials':	{type:'page', page:'backend/Specials',	target:'/admin/specials'},
		'backend/Special':	{type:'page', page:'backend/Special',	target:'/admin/special/:id'},
		'backend/Settings':	{type:'page', page:'backend/Settings',	target:'/admin/settings'},

		'backend/SolidMenu':	{type:'page', page:'backend/Menu',		target:'/admin/menu'},
		'backend/ListMenu':		{type:'page', page:'backend/ListMenu',	target:'/admin/listMenu'},


		'backend/Dummy1s':	{type:'page', page:'backend/Dummy1s',	target:'/admin/dummy1s'},
		'backend/Dummy1':	{type:'page', page:'backend/Dummy1',	target:'/admin/dummy1/:id'},
		
		'backend/StaffResources':	{type:'page', page:'backend/StaffResources',	target:'/admin/staffResources'},
		'backend/StaffResource':	{type:'page', page:'backend/StaffResource',	target:'/admin/staffResource/:id'},

		'frontend/StaffResources':	{type:'page', page:'frontend/StaffResources',	target:'/staffResources'},
		'frontend/StaffResource':	{type:'page', page:'frontend/StaffResource',	target:'/staffResource/:id'},

		'backend/People':	{type:'page', page:'backend/People',	target:'/admin/people'},
		'backend/Person':	{type:'page', page:'backend/Person',	target:'/admin/person/:id'},
		
		//CJ discontinue if 'people' does the job
		'backend/StaffHub':	{type:'page', page:'backend/StaffHub',	target:'/admin/staffHub'},
	};

	/* 
		Example external link:
			'google':         {type:'external', target:'https://google.com'},
	 */
}

